module.exports = __webpack_public_path__ + "officialStatic/img/solution-school.d915bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-school.png
// module id = ni9L
// module chunks = 0